export default "__VITE_ASSET__SSqX9b7w__"